import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';

import styles from './styles.module.scss';
import useSignIn from '../../hooks/useSignIn';

function SignInForm() {
  const {
    phoneNo, onChangePhone, smsAuthNo, onChangeCode, requestSms, requestVerify,
    requestColor, verityColor,
  } = useSignIn();
  return (
        <Column fullWidth as='section' className={styles.container} spacing={12}>
            <Text size='xl' fontWeight='bold'>전화번호로 로그인</Text>
            <Text color={colors.gray7}
                  size='lg'
                  fontWeight='bold'
                  className={styles.comment} >
                휴대전화번호를 입력해주세요
            </Text>
            <Column fullWidth spacing={12}>
                <TextField value={phoneNo}
                           onChange={onChangePhone}
                           placeholder="'-'없이 입력 숫자만 입력"
                           inputMode='numeric'
                           maxLength={13}
                           trailing={
                               <ButtonWrapper type='button'
                                              onClick={requestSms} >
                                   <Text fontWeight='bold' color={requestColor}
                                         className={styles.button} >인증요청</Text>
                               </ButtonWrapper>
                           } />
                <TextField value={smsAuthNo}
                           onChange={onChangeCode}
                           placeholder='인증번호 6자 숫자만 입력'
                           inputMode='numeric'
                           maxLength={6}
                           trailing={
                               <ButtonWrapper onClick={requestVerify}
                               type='button' >
                                   <Text fontWeight='bold' color={verityColor}
                                         className={styles.button} >번호인증</Text>
                               </ButtonWrapper>
                           } />
            </Column>
            <Row spacing={6}>
                <Text color={colors.gray5}
                      size='s' >
                    <b>개인 정보 수탁사</b> NHN
                </Text>
                <div className={styles.div}/>
                <Text color={colors.gray5}
                      size='s' >
                    <b>업무의 내용</b> 인증번호 문자 발송 대행
                </Text>
            </Row>
        </Column>
  );
}

const ButtonWrapper = styled.button`
    padding: 8px 12px;
    background-color: transparent;
`;

export default SignInForm;
